export default __webpack_public_path__ + "static/media/Error-message.69b03c14.svg";